export function isUnauthorizedError(error: Error): boolean {
  return /^401:/.test(error.message);
}

export function redirectToLogin(toast?: (options: {
  title: string;
  description: string;
  variant: "destructive";
}) => unknown) {
  if (toast) {
    toast({
      title: "Unauthorized",
      description: "You are logged out. Logging in again...",
      variant: "destructive",
    });
  }
  setTimeout(() => {
    try {
      sessionStorage.setItem("postLoginRedirect", window.location.pathname + window.location.search);
    } catch {
      // Login still works when storage is unavailable.
    }
    window.location.href = "/login";
  }, 500);
}
